import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let offcanvas = document.querySelectorAll('[paws-component="noss-nav"][paws-template="offcanvas"] .offcanvas');
    if (window.bootstrap != null) {
        for (let i = 0; i < offcanvas.length; ++i) {
            offcanvas[i].addEventListener('hidden.bs.offcanvas', event => {
                event.target.closest('[paws-component="noss-nav"][paws-template="offcanvas"]').classList.remove('open');
            })
            offcanvas[i].addEventListener('show.bs.offcanvas', event => {
                event.target.closest('[paws-component="noss-nav"][paws-template="offcanvas"]').classList.add('open');
            })
        }
    }
}